var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "form-preview",
      class: ["id-" + _vm.formNode.id, _vm.pickFromItemStyle]
    },
    [
      _vm.itemPickControl && _vm.hasPickFun
        ? _c("el-checkbox", {
            model: {
              value: _vm.itemPickModel,
              callback: function($$v) {
                _vm.itemPickModel = $$v
              },
              expression: "itemPickModel"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.itemPickControl && _vm.hasPickFun && _vm.itemPickModel
        ? _c("div", { staticClass: "pick-custom-name" }, [
            _vm._v(_vm._s(_vm.customName))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(_vm.formType && "preview-item-" + _vm.formType, {
        tag: "component",
        attrs: { formNode: _vm.formNode, parent: _vm.parent }
      }),
      _vm._v(" "),
      _vm.isCopied
        ? _c("div", { staticClass: "delete-button" }, [
            _c("span", {
              staticClass: "el-icon-error",
              on: { click: _vm.onDelete }
            })
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-917b2fc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917b2fc0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/preview_item/PreviewItemTemplate.vue
// module id = null
// module chunks = 